import { validateUrls } from "api/types"
import { getServiceURL } from "api/utils"
import { ServicePrefix } from "utils/constants"

const getMercuryURL = getServiceURL(ServicePrefix.mercury)

export const urls = validateUrls({
  lead: {
    getData: () => getMercuryURL(`/v1/lead-profiles/`),
    saveData: userPrimaryKey =>
      getMercuryURL(`/v1/lead-profiles/${userPrimaryKey}/`),
    addQualification: leadProfileId =>
      getMercuryURL(`/v1/lead-profiles/${leadProfileId}/qualifications/`),
    updateQualification: leadQualificationId =>
      getMercuryURL(`/v1/lead-profiles/qualifications/${leadQualificationId}/`),
    deleteQualification: leadQualificationId =>
      getMercuryURL(`/v1/lead-profiles/qualifications/${leadQualificationId}/`),
  },
})
